import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Stack,
  Chip,
} from '@mui/material';
import { WafWhitelistInstructions } from './WafWhitelistInstructions';

/**
 * Shown when the optimize run hit WAF-blocked pages. We do NOT fail over to a
 * paid scrape — instead we ask the retailer's IT to whitelist the Traaker
 * crawler, with the simplest instructions per common WAF (shared component).
 */
export function WafWhitelistDialog({
  open,
  blockedCount,
  sampleUrls,
  onClose,
}: {
  open: boolean;
  blockedCount: number;
  sampleUrls: string[];
  onClose: () => void;
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Pages bloquées par un pare-feu</DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          {blockedCount} page(s) ont été bloquées par le pare-feu du site (Cloudflare, Akamai…).
          Traaker ne contourne pas ces protections — demandez à votre équipe technique
          d'autoriser notre robot.
        </Alert>

        <WafWhitelistInstructions />

        {sampleUrls.length > 0 && (
          <>
            <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
              Exemples de pages bloquées
            </Typography>
            <Stack spacing={0.5}>
              {sampleUrls.map((u) => (
                <Chip key={u} size="small" variant="outlined" label={u} sx={{ maxWidth: '100%' }} />
              ))}
            </Stack>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  );
}
